import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RolPlataforma } from '../../core/models/novedades.models';
import { RoleContextService } from '../../core/services/role-context.service';
import { AccessibilityToolbar } from '../../shared/components/accessibility-toolbar/accessibility-toolbar';
import { BreadcrumbItem, Breadcrumbs } from '../../shared/components/breadcrumbs/breadcrumbs';
import { UserSessionSummary } from '../../shared/components/user-session-summary/user-session-summary';
import { SidebarMenu } from '../../shared/sidebar-menu/sidebar-menu';
import { PatrocinioPanel } from './components/patrocinio-panel/patrocinio-panel';

@Component({
  selector: 'app-patrocinio',
  imports: [CommonModule, SidebarMenu, PatrocinioPanel, AccessibilityToolbar, Breadcrumbs, UserSessionSummary],
  templateUrl: './patrocinio.html',
  styleUrl: './patrocinio.css',
})
export class Patrocinio {
  readonly breadcrumbs: BreadcrumbItem[] = [{ label: 'Inicio', link: '/principal' }, { label: 'Patrocinio' }];
  rol: RolPlataforma = 'representante_institucional';

  constructor(
    private readonly route: ActivatedRoute,
    private readonly roleContext: RoleContextService
  ) {
    this.route.queryParamMap.subscribe((params) => {
      this.rol = this.roleContext.resolveRole(params, this.rol);
    });
  }
}
